import { IDataTableColumn, Loading } from "nsitools-react";
import * as React from "react";

import { PersonApi, PersonGridDto, PersonSearch } from "../../../../api";
import { ICustomSelectorProps, SRSHCustomSelector } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { generateAddress } from "../../../../utils";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ERoutes } from "../../../../ERoutes";

export interface IRequestTransientPersonSelectionProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  editMode: boolean;
  loading: boolean;
  kennelId?: number;
  errors?: any;
}

const Container = styled.div`
  color: RED;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const RequestTransientPersonSelection: React.FunctionComponent<IRequestTransientPersonSelectionProps> = ({
  editMode,
  linkedIds,
  onLinkedIdsChanged,
  loading,
  errors,
  kennelId = null,
}) => {
  const personApi = useApiService(PersonApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "computedName",
        render: (row: PersonGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.personId}/detail/view`}>
            {row.computedName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Address),
        fieldName: "address",
        render: (row: PersonGridDto) => generateAddress(row.number, row.street, row.city, row.postalCode, row.country),
      },
    ],
    [t]
  );

  const searchIdsFunction = React.useCallback(
    (sObj: any) =>
      personApi.getIds(PersonSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, kennelId: kennelId })),
    [currentLanguage.languageId, kennelId, personApi]
  );
  const searchFunction = React.useCallback(
    (sObj: any) =>
      personApi.baseSearch(
        PersonSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, kennelId: kennelId })
      ),
    [currentLanguage.languageId, kennelId, personApi]
  );

  return (
    <Loading isLoading={loading || linkedIds === null}>
      {errors ? (
        <Container>
          <i className="fas fa-exclamation-triangle" />
          <div style={{ marginLeft: "0.5rem" }}> {errors}</div>
        </Container>
      ) : null}
      <SRSHCustomSelector
        linkedIds={linkedIds}
        columns={columns}
        onLinkedIdsChanged={onLinkedIdsChanged}
        idField="personId"
        searchFunction={searchFunction}
        searchIdsFunc={searchIdsFunction}
        editMode={editMode}
      />
    </Loading>
  );
};
